import type { GetStaticPaths, GetStaticProps } from 'next';

import { LOCALES } from '@seuk/shared-data';

import { makeStaticPropsRequest } from '../../modules/pdf/get-static-props';
import makeDocPage from '../../modules/pdf/page';
import type { PageProps } from '../../modules/pdf/types';
import { getCMSClient } from '../../services/cms';

type UrlParams = {
  doc: string;
};

export const getStaticProps: GetStaticProps<PageProps> = async ({ params }) => {
  return makeStaticPropsRequest({ slug: params.doc as string })();
};

export const getStaticPaths: GetStaticPaths<UrlParams> = async () => {
  const entriesPromises = LOCALES.map((locale) =>
    getCMSClient().getAllEntries({ contentType: 'pagePDF', query: { locale } })
  );

  const paths = (await Promise.all(entriesPromises)).flat().map(({ fields }) => ({
    params: { doc: fields.slug },
  }));

  return {
    paths,
    fallback: false,
  };
};

const DocPage = makeDocPage<typeof getStaticProps>();
export default DocPage;
